import { render } from "./PostCardReactions.vue?vue&type=template&id=6902e23e&scoped=true"
import script from "./PostCardReactions.vue?vue&type=script&lang=js"
export * from "./PostCardReactions.vue?vue&type=script&lang=js"

import "./PostCardReactions.vue?vue&type=style&index=0&id=6902e23e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6902e23e"]])

export default __exports__